import React, { useState, useEffect } from 'react';
import { Index } from 'elasticlunr';
import { useStaticQuery, graphql, Link } from 'gatsby';
import { decodeEntities } from '../utils/htmlParse';
import './SearchForm.scss';

export const SearchForm = () => {
  const [query, setQuery] = useState(``);
  const [results, setResults] = useState([]);
  const [index, setIndex] = useState(null);
  const [inputFocused, setInputFocused] = useState(false);

  // Get search index
  const { siteSearchIndex, site: { siteMetadata } } = useStaticQuery(graphql`
    query {
      siteSearchIndex {
        index
      }
      site {
        siteMetadata {
          productsSlug
        }
      }
    }
  `);

  const search = (event) => {
    // Set the search query state
    setQuery(event.target.value);
    // Load the search index
    if (!index) setIndex(Index.load(siteSearchIndex.index));
  };

  // Search the index when index or query state is updated
  useEffect(() => {
    if (index) {
      setResults(
        index
          .search(query, {expand: true})
          .map(({ ref }) => index.documentStore.getDoc(ref))
      );
    }
  }, [index, query]);

  return (
    <div className="search-form" onSubmit={(e) => e.preventDefault}>
      <div className="search-form-input-container">
        <input
          type="text"
          className="search-form-input"
          placeholder="Search by category"
          value={query}
          onChange={search}
          onFocus={() => setInputFocused(true)}
          onBlur={() => setInputFocused(false)}
        />
        <div className="search-results">
          {query && results.length > 0 && results.map(result => {
            return (
              <div className="search-result">
                <Link
                  to={result.link.replace(
                    'services_cat', siteMetadata.productsSlug
                  )}
                >
                  {decodeEntities(result.name)}
                </Link>
              </div>
            );
          })}
          {inputFocused && query && results.length === 0 && (
            <div className="search-result">
              No results matched your query...
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
